import { setCookie } from '@app/services'

import { checkReferrer } from './checkReferrer'
import { getBacktrackCookieName } from './constants'

export const setBacktrack = () => {
  const referrer = document.referrer?.replace(/\/$/, '')
  const useReferrer = referrer && checkReferrer(referrer)
  if (useReferrer) {
    setCookie(getBacktrackCookieName(), referrer, 15 * 24)
  }
}
